import React, { Component } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { NavLink } from "react-router-dom";
import { withRouter } from "../../../withRouter";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import logo from "../../../assets/img/givbeeLogo.png";
import store from "../../../redux/store";
import "./AdminLogin.css";
import AdminHeaderAction from "../../../redux/adminPanel/header/AdminHeaderAction";
import { ApLogin_Url } from "../../../provider/ServiceUrl";
import staticDataAction from "../../../redux/staticData/staticDataAction";
import AdminAppUserDataAction from "../../../redux/adminPanel/appUserData/AdminAppUserDataAction";
import Utils from "../../../provider/Utils";
import ApplicationStateAction from "../../../redux/applicationState/ApplicationStateAction";
class AdminLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      showPassword: false,
      showConfirmPassword: false,
      sendOtpByEmail: true,
      sendOtpByText: true,
      rememberMe: false,
      render: false,
    };
  }


  componentDidMount() {
    store.dispatch(staticDataAction.setStaticData({}));
    store.dispatch(AdminHeaderAction.setAdminHeader({}));
    store.dispatch(AdminAppUserDataAction.setAdminUser({}));
    store.dispatch(ApplicationStateAction.setApplicationState({}));
    const storedHeaderRaw = localStorage.getItem("apHeader");
    const rememberMeFlag = localStorage.getItem("apRememberMe") === "true";

    let storedHeader = null;

    if (storedHeaderRaw && storedHeaderRaw !== "undefined") {
      try {
        storedHeader = JSON.parse(storedHeaderRaw);
      } catch (e) {
        localStorage.removeItem("apHeader");
        localStorage.removeItem("apRememberMe");
      }
    }

    if (rememberMeFlag && storedHeader) {
      this.setState({
        rememberMe: true,
        render: false,
      });

      this.rmLoginInBackend(storedHeader);
    } else {
      localStorage.removeItem("apHeader");
      localStorage.removeItem("apRememberMe");
    }
  }

  handleClickShowPassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }
  handleEmailChange(e) {
    this.setState({ email: e.target.value });
  }
  handlePasswordChange(e) {
    this.setState({ password: e.target.value });
  }

  handleSendOtpByEmailChange(e) {
    this.setState({ sendOtpByEmail: e.target.checked, error: false });
  }
  handleSendOtpByTextChange(e) {
    this.setState({ sendOtpByText: e.target.checked, error: false });
  }

  processLoginSuccess(output_data) {
    let headerObj = output_data.header;
    store.dispatch(AdminHeaderAction.setAdminHeader(headerObj));
    let menus = output_data.appuser.profile.menus.sort(
      (a, b) => a.displaysequence - b.displaysequence
    );
    for (const menu of menus) {
      if (menu.isactive) {
        this.props.navigate(menu.pageid);
        break;
      }
    }
  }

  userLoginInBackend() {
    if (!this.state.sendOtpByEmail && !this.state.sendOtpByText) {
      this.setState({
        error: true,
      });
      return;
    }
    const postObject = {
      header: { appclient: "W" },
      appuser: {
        email: this.state.email,
        credential: this.state.password,
        sendOtpByEmail: this.state.sendOtpByEmail,
        sendOtpByText: this.state.sendOtpByText,
        isRememberMe: this.state.rememberMe,
      },
    };
    AdminFetchServerData.callPostService(ApLogin_Url, postObject)
      .then((response) => {
        let output = response;
        let header = response.data.header;
        if (output.status === "SUCCESS") {
          store.dispatch(AdminHeaderAction.setAdminHeader(header));
          this.props.navigate("/ApVerifyotp");
        }
      })
      .catch((error) => { });
  }


  rmLoginInBackend = (header) => {
    const postObject = {
      header: header,
    };

    AdminFetchServerData.callPostService("/apAppuserms/rmlogin", postObject)
      .then((response) => {
        if (Utils.equalsIgnoreCase(response.status, "SUCCESS")) {
          let output = response.data;
          let appuser = response.data?.appuser;
          let header = response.data.header;
          store.dispatch(
            AdminAppUserDataAction.setAdminUser(appuser)
          );
          store.dispatch(AdminHeaderAction.setAdminHeader(header));
          this.processLoginSuccess(output);
          if (appuser.isRememberMe) {
            localStorage.setItem("apRememberMe", appuser.isRememberMe);
            localStorage.setItem("apHeader", JSON.stringify(this.header));
          }
        }
      })
      .catch((error) => { });
  };

  handleCheckboxChange = () => {
    this.setState((prevState) => ({ rememberMe: !prevState.rememberMe }));
  };

  render() {
    return (
      <div className="authentication-wrapper authentication-cover">
        <div className="authentication-inner row" id="signIn">
          <div className="d-flex col-12 col-lg-6 col-xl-6 align-items-center apLeftBackground">
            <div className="mx-auto">
              <div className="logoBackground">
                <img
                  src={logo}
                  className="img-fluid logoImage"
                  alt=""
                  data-app-dark-img="illustrations/girl-with-laptop-dark.png"
                  data-app-light-img="illustrations/girl-with-laptop-light.png"
                />
              </div>
            </div>
          </div>
          <div className="d-flex col-12 col-lg-6 col-xl-6 align-items-center authentication-bg p-sm-5 p-4">
            <div className="w-px-400 mx-auto">
              <div className="adminSigninHeding text-start ps-2">
                Admin Panel
              </div>
              <h3 className="text-start pt-2">Sign In</h3>
              <ValidatorForm
                ref="form"
                id="formAuthentication"
                className="mb-3"
                onSubmit={this.userLoginInBackend.bind(this)}
              >
                <div className="mb-3">
                  <label className="form-label" htmlFor="multiStepsEmail">
                    User ID <span className="fw-normal">(email address)</span>
                  </label>
                  <input
                    required
                    title=""
                    autoFocus={true}
                    type="email"
                    name="multiStepsEmail"
                    value={this.state.email}
                    onChange={this.handleEmailChange.bind(this)}
                    id="multiStepsEmail"
                    className="form-control"
                    aria-label="john.doe"
                  />
                </div>
                <div className="mb-3 form-password-toggle">
                  <label className="form-label" htmlFor="multiStepsEmail">
                    Password
                  </label>
                  <div className="input-group input-group-merge">
                    <input
                      type={this.state.showPassword ? "text" : "password"}
                      id="password"
                      name="password"
                      className="form-control"
                      aria-describedby="multiStepsPass2"
                      onChange={this.handlePasswordChange.bind(this)}
                      value={this.state.password}
                    />
                    <span
                      className="input-group-text cursor-pointer"
                      id="multiStepsPass2"
                      onClick={this.handleClickShowPassword.bind(this)}
                    >
                      {this.state.showPassword ? (
                        <VisibilityIcon />
                      ) : (
                        <VisibilityOffIcon />
                      )}
                    </span>
                  </div>
                </div>

                {/* <div className="row d-flex">
                    <label className="form-label" htmlFor="multiStepsPass">
                      Send verification code as:
                    </label>
                    <div className="col-md-2 d-flex">
                      <span className="me-2" style={{ marginTop: "2px" }}>
                        <input
                          type="checkbox"
                          style={{ cursor: "pointer" }}
                          value={this.state.sendOtpByText}
                          onChange={(e) => this.handleSendOtpByTextChange(e)}
                          checked={this.state.sendOtpByText}
                        />
                      </span>
                      <p className="form-label " htmlFor="collapsible-lastname">
                        SMS
                      </p>
                    </div>
                    <div className="col-md-3 d-flex">
                      <span className="me-2" style={{ marginTop: "2px" }}>
                        <input
                          type="checkbox"
                          style={{ cursor: "pointer" }}
                          value={this.state.sendOtpByEmail}
                          onChange={(e) => this.handleSendOtpByEmailChange(e)}
                          checked={this.state.sendOtpByEmail}
                        />
                      </span>
                      <p className="form-label " htmlFor="collapsible-lastname">
                        Email
                      </p>
                    </div>

                    {this.state.error ? (
                      <lable
                        className="danger"
                        style={{ color: "red", padding: "0px 43px" }}
                      >
                        Please Select Checkbox
                      </lable>
                    ) : (
                      ""
                    )}
                  </div> */}

                <div className="row mb-2 d-flex">
                  <div className="col-md-8 d-flex rememberMeCheckbox">
                    <FormControlLabel
                      style={{
                        width: "100%",
                        margin: "0",
                        padding: "0",
                        alignItems: "flex-start",
                      }}
                      control={
                        <Checkbox
                          variant="outlined"
                          id="rememberMe"
                          checked={this.state.rememberMe}
                          onChange={this.handleCheckboxChange.bind(this)}
                          style={{
                            background: "none",
                          }}
                        />
                      }
                      label={
                        <span
                          className="form-label fw-normal"
                          style={{
                            fontSize: "14px",
                            margin: "0 8px 0 4px",
                            wordWrap: "break-word",
                            whiteSpace: "normal",
                            lineHeight: "1.2",
                          }}
                        >
                          Remember me on this device
                        </span>
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <NavLink
                      to="/ApForgotPassword"
                      style={{ float: "right", marginBottom: "10px" }}
                    >
                      <span>Forgot Password?</span>
                    </NavLink>
                  </div>
                </div>
                <button type="submit" className="siginButton d-grid w-100">
                  Sign In
                </button>
              </ValidatorForm>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(AdminLogin);
